import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const LinkedinLikeReactionIcon = ({
  color = colors.black,
  className,
  onClick,
  style,
  size = 16,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...style}
    >
      <path
        d="M0 12C0 14.2056 1.7944 16 4 16H5.33333C5.70152 16 6 15.7015 6 15.3333C6 14.9651 5.70152 14.6667 5.33333 14.6667H4C2.5296 14.6667 1.33333 13.4704 1.33333 12V4C1.33333 2.5296 2.5296 1.33333 4 1.33333H12C13.4704 1.33333 14.6667 2.5296 14.6667 4V9.87099C14.6667 9.87099 15.5 9.87099 16 10.3065V4C16 1.7944 14.2056 0 12 0H4C1.7944 0 0 1.7944 0 4V12Z"
        fill={color}
      />
      <path
        d="M5.33333 6.6064V11.3333C5.33333 11.7015 5.0348 12 4.66667 12C4.29853 12 4 11.7015 4 11.3333V6.6064C4 6.23827 4.29853 5.93974 4.66667 5.93974C5.0348 5.93974 5.33333 6.23827 5.33333 6.6064ZM4.66667 3.73334C4.29853 3.73334 4 4.03187 4 4.4V4.53334C4 4.90147 4.29853 5.2 4.66667 5.2C5.0348 5.2 5.33333 4.90147 5.33333 4.53334V4.4C5.33333 4.03187 5.0348 3.73334 4.66667 3.73334ZM10.2025 6.02907C9.53613 5.89814 8.71347 6.07214 7.9968 6.63627C7.98 6.28307 7.69067 6.00107 7.33333 6.00107C6.9652 6.00107 6.66667 6.2996 6.66667 6.66774V10.0751C6.66667 10.4432 6.9652 10.7417 7.33333 10.7417C7.70147 10.7417 8 10.4432 8 10.0751V8.84627C8.00773 8.83094 8.01747 8.8172 8.02413 8.80094C8.4816 7.682 9.3368 7.2176 9.94547 7.3372C10.2643 7.39981 10.4886 7.61983 10.5955 7.96137C11 7.5 11.5 7.3372 11.7704 7.30991C11.4788 6.64006 10.9253 6.17108 10.2025 6.02907Z"
        fill={color}
      />
      <path
        d="M9 12.0484H7.87012C7.59397 12.0484 7.37012 12.272 7.37012 12.5482C7.37012 13.4095 7.37012 14.4125 7.37012 14.9992C7.37012 15.2753 7.59397 15.4984 7.87012 15.4984H10.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        id="thumb-up"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5185 11.2342C14.9671 11.2342 15.3307 11.5978 15.3307 12.0464V13.3835C15.3308 13.5441 15.2835 13.7011 15.1947 13.8349L14.3265 15.1392C14.1762 15.3653 13.9227 15.5011 13.6512 15.5009H10.2537C9.80507 15.5009 9.44141 15.1373 9.44141 14.6887V12.4063C9.44148 12.112 9.52151 11.8232 9.67293 11.5709L10.9781 9.39455C11.1249 9.14939 11.3898 8.99952 11.6756 9H12.0615C12.2878 9 12.5048 9.08998 12.6648 9.25011C12.8248 9.41025 12.9145 9.6274 12.9142 9.85374V11.2342H14.5185Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        id="thumb-up"
      />
    </svg>
  );
};

export default LinkedinLikeReactionIcon;
